export default __webpack_public_path__ + "static/media/efectohaas.e4e75dce.png";